import * as THREE from 'three';
import { CanvasInfo } from "../../view3d/base";
import { baseCommand } from './basecommand';

type imagesizetypename = "image_size";

type imagesizedatatype = {
    "width": number,
    "height": number
}

type pscommand<T> = {
    "type": T extends imagesizetypename ? T : never;
    "data": T extends imagesizetypename ? imagesizedatatype : never;
};

export type imagesizeCommand = pscommand<imagesizetypename>;

export class imagesize extends baseCommand {
    public type: imagesizetypename = "image_size";

    constructor() {
        super();
    }

    private renderImage(): THREE.Vector2 {
        const { size } = CanvasInfo.get();
        return size;
    }

    public object(): imagesizeCommand {
        const imagesize = this.renderImage();
        return {
            "type" : this.type,
            "data" : {
                "width": imagesize.x,
                "height": imagesize.y
            }
        }
    }
}
